<template>
  <div class="posi-fiexd" v-if="dataVal.flag">
    <div class="posi-center">
      <div class="posi-head">
        <div class="posi-title">{{ dataVal.title }}</div>
        <i @click="handleClose" class="el-icon-close"></i>
      </div>
      <div class="posi-over">
        <div class="posi-from">
          <div class="posi-item">
            <div class="posi-item-title" @click="handleOpen">
              点击下载导入模板
            </div>
            <div class="posi-item-input" v-if="!disable">
              <el-upload
                ref="upload"
                class="upload-demo"
                drag
                :headers="headers"
                :action="uploadfile"
                :show-file-list="false"
                :on-success="handleSuccess"
                :on-progress="handleProgress"
                :before-upload="beforeAvatarUpload"
                :file-list="fileList2"
                :disabled="disable"
                :limit="1"
                multiple
              >
                <div class="drag">
                  <img src="@/assets/images/basicBusiness/upload.png" alt="" />
                  <div>请点击上传附件或拖动到此位置上传</div>
                </div>
              </el-upload>
            </div>
            <div class="posi-upload">
              <div
                class="posi-upload-item"
                v-loading="item.percent != 100 && item.statusbar == '上传中'"
                element-loading-text="上传中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(0, 0, 0, 0.8)"
                v-for="(item, i) in fileList"
                :key="item.uid"
                @click="handleDown(item.url)"
              >
                <div>{{ item.url }}</div>
                <i
                  v-if="disable == false"
                  @click="handleRemove(i)"
                  class="el-icon-circle-close"
                ></i>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="posi-btn" v-if="disable == false">
        <div class="hui" @click="handleClose">{{ dataVal.btn2 || "取消" }}</div>
        <div @click="handleSubmit">{{ dataVal.btn1 || "确认" }}</div>
      </div>
    </div>
  </div>
</template>
  <script>
export default {
  name: "FillIn",
  props: ["dataVal"],
  data() {
    return {
      headers: {
        token: localStorage.getItem("token"),
        type: localStorage.getItem("type"),
      },
      fileList: [],
      fileList2: [],
      item: null,
      disable: false,
      fileObj: {
        fileurl: "",
      },
      //处理结果 2=处理中，3=处理完成
      statusArr: [
        { id: 2, name: "处理中" },
        { id: 3, name: "处理完成" },
      ],
      status: 2,
      flag:false
    };
  },
  mounted() {},
  methods: {
    //点击预览图片或者pdf
    handleDown(name) {
      if (this.getFileType(name) == "image") {
        window.open(this.imgurl + name, "_blank");
      } else if (this.getFileType(name) == "document") {
        window.open("/#/indexpdf?src=" + this.imgurl + name, "_blank");
      } else {
      }
    },
    //用于判断字符串是否以图片或 Word、PDF、Excel 文档的后缀结尾
    getFileType(filename) {
      // 将文件名转换为小写，以便进行不区分大小写的比较
      const lowerCaseFilename = filename.toLowerCase();

      // 定义图片后缀数组
      const imageExtensions = [
        ".jpg",
        ".jpeg",
        ".png",
        ".gif",
        ".bmp",
        ".tiff",
      ];

      // 定义文档后缀数组
      const documentExtensions = [".doc", ".docx", ".pdf", ".xls", ".xlsx"];

      // 检查文件是否是图片
      for (let ext of imageExtensions) {
        if (lowerCaseFilename.endsWith(ext)) {
          return "image";
        }
      }

      // 检查文件是否是 Word、PDF、Excel 文档
      for (let ext of documentExtensions) {
        if (lowerCaseFilename.endsWith(ext)) {
          return "document";
        }
      }

      // 如果都不是，返回未知类型
      return "unknown";
    },
    handleStatus(item) {
      this.status = item.id;
    },
    //上传中
    handleProgress(response, file, fileList) {
      console.log(file, 111);
      let i = -1;
      this.fileList.forEach((item, index) => {
        if (item.uid == file.uid) {
          this.fileList.splice(index, 1, {
            uid: file.uid,
            url: file.name,
            percent: response.percent,
            statusbar: "上传中",
          });
          i = index;
          if (response.percent == 100) {
            this.fileList.splice(index, 1);
          }
        }
      });
      if (i == -1 && response.percent != 100) {
        this.fileList.push({
          uid: file.uid,
          url: file.name,
          percent: response.percent,
          statusbar: "上传中",
        });
      }
    },
    beforeAvatarUpload(file) {
      var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      const extension = testmsg === "xls" || testmsg === "xlsx";
      if (!extension) {
        this.$message({
          message: "上传文件只能是.xls、.xlsx格式!",

          type: "warning",
        });
      }
      return extension;
    },
    handleSuccess(res, fileList) {
      this.fileList.push({
        uid: res.data.file,
        url: res.data.file,
        percent: 100,
        statusbar: "上传成功",
      });
    },
    handleRemove(index) {
      this.fileList.splice(index, 1);
    },
    //提交
    async handleSubmit() {
      if (!this.flag) {
        this.flag = true;
        let arr = this.fileList.map((item) => item.url);
        this.fileObj.fileurl = arr.toString();
        let res = await this.$api.shopImportcate({
          ...this.fileObj,
        });
        if (res.code == 1) {
          this.flag = false;
          let obj = {
            flag: false,
            submitFlag: true,
          };
          this.$emit("fillInCell", obj);
          this.$message.success(res.msg);
        } else {
          this.flag = false;
        }
      }
    },
    handleOpen() {
      window.location.href = this.imgurl + "/uploads/doc/cate.xlsx";
    },
    //关闭
    handleClose() {
      let obj = {
        flag: false,
        submitFlag: false,
      };
      this.$emit("fillInCell", obj);
    },
  },
  watch: {
    dataVal: {
      handler(newVal, oldVal) {
        this.flag = false;
        this.fileObj.file = "";
        this.fileList = [];
        this.fileList2 = [];
      },
      deep: true,
    },
  },
};
</script>
  <style lang="scss" scoped>
.posi-fiexd {
  @include flex-center(center, center);
}
.posi-center {
  width: 1016px;
  height: 40vh;
  border-radius: 25px;
  background-color: #fff;
  overflow: hidden;
  .posi-head {
    height: 70px;
    padding: 0 36px 0 32px;
    background-color: #f2f6ff;
    @include flex-center(space-between, center);
    .posi-title {
      font-size: 20px;
      font-weight: 700;
      color: #202224;
    }
    i {
      font-size: 20px;
      color: #aeaeb2;
      cursor: pointer;
    }
  }
  .posi-over {
    height: calc(45vh - 235px);
    padding: 21px 41px 0;
    overflow: auto;
  }
  .posi-from {
    .posi-item {
      width: 100%;
      .sex {
        width: 100%;
        height: 60px;
        background-color: #f2f2f7;
        border: 1px solid #f2f2f7;
        @include flex-center(center, center);
        border-radius: 10px;
        .sex-item {
          @include flex-center(center, center);
          color: #000000;
          font-size: $f-size-14;
          cursor: pointer;
          .sex-yuan {
            width: 10px;
            height: 10px;
            border: 1px solid #aeaeb2;
            border-radius: 50%;
            margin-right: 6px;
          }
          .sex-active {
            background-color: $y-color;
            border: 1px solid $y-color;
          }
          &:first-child {
            margin-right: 91px;
          }
          &:hover {
            color: $y-color;
          }
        }
      }
      .posi-item-title {
        color: $y-color;
        font-size: $f-size-13;
        font-weight: 600;
        margin-bottom: 20px;
        display: flex;
        cursor: pointer;
        span {
          color: #ff3b30;
          font-size: $f-size-13;
        }
      }

      .posi-item-input {
        width: 100%;
        input {
          width: 100%;
          height: 52px;
          background-color: #f5f6fa;
          color: #000;
          font-size: 14px;
          border: 1px solid #d5d5d5;
          outline: none;
          padding-left: 16px;
        }
        /deep/.upload-demo {
          .el-upload {
            width: 100%;
          }
          .el-upload-dragger {
            width: 100%;
            background-color: #f5f6fa;
            height: 60px;
          }
          .drag {
            @include flex-center(center, center);
            font-size: $f-size-13;
            color: #aeaeb2;
            height: 60px;
            img {
              width: 35px;
              height: 35px;
              margin-right: 9px;
            }
          }
        }
        /deep/.el-input__inner {
          height: 52px;
          line-height: 52px;
          background-color: #f5f6fa;
          color: #000;
          font-size: 14px;
          border: 1px solid #d5d5d5;
        }
        /deep/.el-textarea {
          width: 100%;
          .el-textarea__inner {
            height: 272px;
            width: 100%;
            background-color: #f5f6fa;
            color: #000;
            font-size: 14px;
            border: 1px solid #d5d5d5;
            resize: none;
          }
          .el-input__count {
            background-color: #f5f6fa;
            color: #000;
          }
        }
      }
      .posi-upload {
        @include flex-center(flex-start, center);
        flex-wrap: wrap;
        font-size: $f-size-13;
        color: $y-color;
        .posi-upload-item {
          margin: 13px 22px 13px 0;
          display: flex;
          align-items: center;
          padding: 10px 7px;
          border-radius: 5px;
          background-color: #f2f2f7;
          div {
            margin-right: 6px;
          }
          i {
            flex-shrink: 0;
            color: #d1d1d6;
            font-size: 15px;
            cursor: pointer;
            margin-top: 3px;
          }
        }
      }
    }
    .mb-36 {
      margin-bottom: 36px;
    }
    .mt-36 {
      margin-top: 36px;
    }
  }
  .posi-btn {
    padding-top: 40px;
    @include flex-center(center, center);
    div {
      width: 100px;
      height: 35px;
      background-color: #4a4b9d;
      border-radius: 4px;
      font-size: 12px;
      font-weight: 400;
      color: #fff;
      @include flex-center(center, center);

      cursor: pointer;
    }
    .hui {
      margin-right: 42px;
      background-color: #f5f5f5;
      color: #363636;
    }
  }
}
</style>